import { format } from 'date-fns';

import { formatDateToInput, formatYearMonthDayToDate } from 'utils/dateUtils';

export const toShiftDateKeyFromIso = (isoDate: string): string => formatDateToInput(new Date(isoDate));

export const parseShiftDateKey = (dateKey: string): Date | null => formatYearMonthDayToDate(dateKey);

export const toDateKeyFromDate = (date: Date): string => format(date, 'yyyy-MM-dd');

export const doesShiftDateKeyMatch = (shiftDateKey: string, date: Date): boolean =>
  shiftDateKey === toDateKeyFromDate(date);

export const formatShiftDateLabel = (dateKey: string): string => {
  const date = parseShiftDateKey(dateKey);
  if (!date) return '';

  return format(date, 'MMM d, yyyy');
};
